import React from 'react'
import {Lang} from 'yougile-lang'
import {TwGuest, TwName, TwUserName} from './containers'
import {UserNameBaseProps} from './types'
import {getTitle} from './utils'

export const UserNameBase = ({
  name,
  type = 'normal',
  context = 'ui',
  className
}: UserNameBaseProps) => (
  <TwUserName
    $context={context}
    title={getTitle(type, name)}
    className={className}
  >
    {name && (
      <TwName $context={context} $type={type}>
        {name}
      </TwName>
    )}
    {(!name || type === 'guest') && (
      <TwGuest $context={context}>{Lang.msg.share.guest}</TwGuest>
    )}
  </TwUserName>
)
